export default "__VITE_ASSET__Bb0oFkG5__"